import React from "react";
import { TermsData } from "./TermsData";
import NavBar from "../../components/NavBar/NavBar";
import Pitch from "../../components/Pitch/Pitch";
import Footer from "../../components/Footer/Footer";
import "./Terms.css";

const Terms = () => {
  return (
    <div>
      <NavBar />

      <div style={styles.container}>
        <div style={styles.centerBlock}>
          <div style={styles.header}>
            <h3 style={styles.title}>Terms of Use for MedScroll</h3>
            <p>Last Updated: 8th April, 2025</p>
          </div>

          <ul style={styles.list}>
            <li style={styles.li}>
              <span style={styles.bold}>Introduction</span>
              <p style={styles.paragraph}>
                Welcome to MedScroll, an AI-powered learning ecosystem operated
                by Loopscribe Pty Ltd (“MedScroll”, “we”, “us”, or “our”). These
                Terms of Use (“Terms”) govern your access to and use of the
                MedScroll services, which include both web and mobile
                applications. By using MedScroll, you agree to be bound by these
                Terms.
              </p>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>Company Information</span>
              <ul style={styles.innerList}>
                <li>
                  <span>
                    <span style={styles.bold}>Company Name:</span> Loopscribe
                    Pty Ltd
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Address:</span> Level 1/390 St
                    Kilda Road, Melbourne VIC 3004, Australia
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Contact Email:</span>{" "}
                    hello@loopscribe.com
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Jurisdiction:</span> Australia
                  </span>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>Description of Services</span>
              <p style={styles.paragraph}>
                MedScroll provides a diverse range of educational and
                interactive learning services. The platform is available as both
                a web app and a mobile app; however, not all services are
                available on both platforms. Our services include:
              </p>
              <ul style={styles.innerList}>
                <li>
                  <span style={styles.bold}>Learning Services:</span>
                  <ul style={styles.innerList}>
                    <li>
                      <span>
                        <span style={styles.bold}>Quizzes:</span> Engage in
                        quizzes available in single-player, multiplayer, and
                        presentation modes to facilitate interactive learning.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span style={styles.bold}>Educational Resources:</span>{" "}
                        Access tutorials, courses, and simulations designed to
                        enhance your knowledge and practical skills.
                      </span>
                    </li>
                  </ul>
                </li>
                <li>
                  <span style={styles.bold}>MedScroll Slides:</span>
                  <p style={styles.paragraph}>
                    A dedicated platform for presentations that offers
                    AI-powered assistance for slide content creation. MedScroll
                    Slides allows users to build and refine presentation slides
                    with the support of our intelligent assistant.
                  </p>
                </li>
                <li>
                  <span style={styles.bold}>MedScroll Clinical Exams:</span>
                  <p style={styles.paragraph}>
                    An AI-powered service that provides realistic patient and
                    examiner simulations. This service is designed for
                    practicing clinical skills and preparing for clinical
                    examinations. In addition to simulations, MedScroll Clinical
                    Exams offers tutorials and other educational resources aimed
                    at supporting healthcare professionals and students.
                  </p>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>User Accounts</span>
              <ul style={styles.innerList}>
                <li>
                  <span>
                    <span style={styles.bold}>Account Requirements:</span> Users
                    must provide their name and email address to create an
                    account.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Age Restrictions:</span> Users
                    must be at least 13 years old to use MedScroll. Users below
                    16 years must obtain parental consent prior to using the
                    app. account.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Account Security:</span> Users are
                    responsible for maintaining the confidentiality of their
                    account information and for all activities that occur under
                    their account. You must notify us immediately of any
                    unauthorized use of your account. account.
                  </span>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>User Conduct</span>
              <p style={styles.paragraph}>
                Users agree to use MedScroll in accordance with the following
                guidelines:
              </p>

              <ul style={styles.innerList}>
                <li>
                  Refrain from engaging in illegal activities, harassment, or
                  misuse of the platform.
                </li>
                <li>
                  Avoid uploading, posting, or sharing content that is
                  defamatory, obscene, offensive, or that violates the rights of
                  others.
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>User-Generated Content</span>
              <ul style={styles.innerList}>
                <li>
                  <span>
                    <span style={styles.bold}>Ownership:</span> Users retain
                    ownership of the content they create on MedScroll.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Licensing Terms:</span> By
                    creating and sharing content on MedScroll, you grant
                    MedScroll a non-exclusive, royalty-free license to use,
                    reproduce, and distribute your content as set by your
                    designated privacy settings. Private content remains
                    accessible only to you, while public content is viewable by
                    all users. Additionally, you grant MedScroll permission to
                    use anonymized data derived from your content to personalize
                    your experience.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Moderation Policies:</span>{" "}
                    MedScroll reserves the right to review and remove any
                    content that violates these Terms or is deemed
                    inappropriate.
                  </span>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>Intellectual Property</span>
              <ul style={styles.innerList}>
                <li>
                  <span>
                    <span style={styles.bold}>Platform Content Ownership:</span>{" "}
                    MedScroll retains ownership of all proprietary content
                    provided by us, including AI-generated content that forms
                    parts of our quizzes, tutorials, simulations, and other
                    educational materials.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Usage Permissions:</span> Users
                    may utilize content provided by MedScroll solely for
                    personal and educational purposes. Any commercial use or
                    redistribution requires prior written consent from
                    MedScroll.
                  </span>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>
                Disclaimers and Limitation of Liability
              </span>
              <ul style={styles.innerList}>
                <li>
                  <span>
                    <span style={styles.bold}>
                      Educational and Entertainment Purposes:
                    </span>{" "}
                    MedScroll is intended for educational and entertainment
                    purposes only. Our content is not a substitute for
                    professional advice, including but not limited to medical
                    advice or professional practice recommendations.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Accuracy Disclaimer:</span> While
                    MedScroll employs advanced AI, errors may occur in content
                    and outputs. Users are advised to verify the accuracy of the
                    content independently.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Limitation of Liability:</span>{" "}
                    MedScroll is not liable for any direct, indirect,
                    incidental, punitive, or consequential damages arising from
                    your use of our services.
                  </span>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>Termination of Service</span>
              <ul style={styles.innerList}>
                <li>
                  <span>
                    <span style={styles.bold}>Termination Conditions:</span>{" "}
                    MedScroll reserves the right to terminate or suspend user
                    accounts that violate these Terms.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Voluntary Termination:</span> You
                    may delete your account at any time using the account
                    deletion feature within the app.
                  </span>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>Payment and Subscriptions</span>
              <ul style={styles.innerList}>
                <li>
                  <span>
                    <span style={styles.bold}>Subscription Tiers:</span>{" "}
                    MedScroll offers tiered subscription plans. Some content and
                    AI features are exclusive to certain subscription tiers or
                    require one-time purchase.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Free Trial and Credits:</span> New
                    users are offered free credit with a free trial of MedScroll
                    services.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Refund Policies:</span> New
                    Subscription cancellations will take effect from the next
                    billing period. Please note that AI credit allowances are
                    provided monthly and do not carry over to subsequent months.
                  </span>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>
                Governing Law and Dispute Resolution
              </span>
              <ul style={styles.innerList}>
                <li>
                  <span>
                    <span style={styles.bold}>Governing Law:</span> These Terms
                    are governed by the laws of Queensland, Australia.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>Dispute Resolution:</span> Any
                    disputes arising under or in connection with these Terms
                    will be resolved in the courts of Queensland, Australia.
                  </span>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>Privacy and Data Protection</span>
              <p style={styles.paragraph}>
                Our privacy practices are governed by our Privacy Policy, which
                complies with the Australian Privacy Act, GDPR, CCPA, and other
                applicable global data protection laws. Please see our separate
                Privacy Policy document for detailed information.
              </p>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>
                Compliance with Global Regulations
              </span>
              <p style={styles.paragraph}>
                MedScroll is committed to maintaining compliance with various
                data protection laws, including:
              </p>
              <ul style={styles.innerList}>
                <li>
                  <span>
                    <span style={styles.bold}>Australian Privacy Act:</span> We
                    adhere to strict standards for data collection, storage, and
                    processing as mandated under Australian law.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>GDPR:</span> For users in the
                    European Union, we ensure that data is processed lawfully,
                    transparently, and securely, and we provide rights such as
                    access, correction, and deletion.
                  </span>
                </li>
                <li>
                  <span>
                    <span style={styles.bold}>CCPA:</span> For Californian
                    users, we offer transparency regarding the personal data we
                    collect, the purposes for which it is used, and provide the
                    right to request deletion, among other rights.
                  </span>
                  <p>
                    For additional details, please refer to Section 14 of this
                    document.
                  </p>
                </li>
              </ul>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>
                GDPR and CCPA Specific Disclosures
              </span>
              <ul style={styles.innerList}>
                <li>
                  <span style={styles.bold}>GDPR:</span>
                  <ul style={styles.innerList}>
                    <li>
                      <span>
                        <span style={styles.bold}>
                          Transparency and Consent:
                        </span>{" "}
                        We provide clear, concise information on data processing
                        and obtain your consent where necessary.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span>User Rights:</span> EU users have rights to
                        access, correct, delete, or restrict processing of their
                        personal data, as well as rights to data portability and
                        to object to processing.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span>Data Protection Measures:</span> We implement
                        appropriate technical and organizational measures to
                        safeguard your data.
                      </span>
                    </li>
                  </ul>
                </li>
                <li>
                  <span style={styles.bold}>CCPA:</span>
                  <ul style={styles.innerList}>
                    <li>
                      <span>
                        <span style={styles.bold}>Right to Know:</span>{" "}
                        California residents have the right to request
                        disclosure of the categories and specific pieces of
                        personal data we collect, along with the purposes for
                        such collection.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span>Right to Delete:</span> Eligible California users
                        may request that we delete their personal data, subject
                        to certain exceptions.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span>Right to Opt-Out:</span> You have the right to
                        opt-out of the sale of your personal data (note: we do
                        not sell personal data).
                      </span>
                    </li>
                    <li>
                      <span>
                        <span>Non-Discrimination:</span> Exercising your CCPA
                        rights will not result in differential treatment of your
                        account or services.
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
              <p>
                Our practices are designed to provide you with clear choices and
                robust protection for your data.
              </p>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>Changes to These Terms</span>
              <p>
                MedScroll reserves the right to update these Terms at any time.
                You will be notified of any material changes via email, and
                continued use of the platform constitutes acceptance of the
                updated Terms.
              </p>
            </li>

            <li style={styles.li}>
              <span style={styles.bold}>Contact Information</span>
              <p>
                If you have any questions or concerns about these Terms, please
                contact us at:
              </p>
              <span>
                <span style={styles.bold}>Email:</span> hello@loopscribe.com
              </span>
            </li>
          </ul>
        </div>
      </div>

      <Pitch />
      <Footer />
    </div>
  );
};

export default Terms;

const styles: any = {
  container: {
    backgroundColor: "white",
    color: "black",
    display: "flex",
    flexDirection: "column",
    gap: "2.5rem",
    padding: "1.25rem",
    fontFamily: "Arial, sans-serif",
    fontSize: "14px",
    lineHeight: "1.6",
  },
  centerBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "2.5rem",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: "0.5rem",
  },
  title: {
    fontSize: "30px",
    fontWeight: "600",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    paddingBottom: "5rem",
    paddingLeft: "1.25rem",
    paddingRight: "1.25rem",
    listStyleType: "decimal",
  },
  li: {
    marginBottom: "1rem",
  },
  innerList: {
    marginTop: "0.5rem",
    paddingLeft: "1.5rem",
    listStyleType: "disc",
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  paragraph: {
    marginTop: "0.5rem",
  },
  bold: {
    fontWeight: "600",
  },
};
